"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormItemProvider = _interopRequireDefault(require("../Utility/FormItemProvider"));

var _Select = _interopRequireDefault(require("../Select/Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FormItem = (0, _FormItemProvider.default)(_Select.default);
/**
 * This is a container component that wraps Select with FormItemProvider.
 *
 * See <a href="/#!/Select">Select</a> and <a href="#!/FormItemProvider">FormItemProvider</a>
 *  for props that can be used
 */

var FormItemSelect =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormItemSelect, _React$Component);

  function FormItemSelect() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, FormItemSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormItemSelect)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleSelectedChange = function (selectedRow) {
      var _this$props = _this.props,
          formHelper = _this$props.formHelper,
          id = _this$props.id;

      if (formHelper.handleValidation) {
        formHelper.handleValidation(id, selectedRow);
      }
    }, _temp));
  }

  _createClass(FormItemSelect, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          error = _this$props2.error,
          helpText = _this$props2.helpText,
          formHelper = _this$props2.formHelper,
          props = _objectWithoutProperties(_this$props2, ["id", "error", "helpText", "formHelper"]); // If formHelper is defined, it should override error and helpText


      var formHelperProps = {
        error: error,
        helpText: helpText
      };

      if (formHelper) {
        if (formHelper.errors && formHelper.errors[id]) {
          if (formHelper.errors[id].message) {
            formHelperProps.helpText = formHelper.errors[id].message;
          }

          formHelperProps.error = formHelper.errors[id].error;
        }

        if (formHelper.values && formHelper.values[id]) {
          formHelperProps.selectedRow = _objectSpread({}, formHelper.values[id]);
        }

        if (formHelper.handleChange) {
          formHelperProps.onSelectedChange = this.handleSelectedChange;
        }
      }

      return _react.default.createElement(FormItem, _extends({
        id: id
      }, formHelperProps, props));
    }
    /**
     * Event handler for Select onSelectedChange
     * @param {Object} selectedRow - Selected row object
     */

  }]);

  return FormItemSelect;
}(_react.default.Component);

exports.default = FormItemSelect;
FormItemSelect.propTypes = {
  /**
   * Unique id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Validation helper object provided by Form component
   */
  formHelper: _propTypes.default.object
};